import React, { useState } from 'react'
import * as styles from './MapGrid.module.scss'
import {
  DivideByAttributeIcon,
  EditorModeIcon,
  FormsIcon,
  PresentModeIcon,
  UserIcon
} from '@atlas-co/icons'
import { Link } from '../../context/BaseUrlContext'
import kebabCase from 'lodash/kebabCase'
import { Tooltip } from '@mantine/core'

const MapGrid = ({ title, maps, small }) => {
  return (
    <>
      <div className={styles.section}>
        <div className={styles.content}>
          <div>
            {title && <h2>{title}</h2>}
            <div className={`${styles.grid} ${small && styles.small}`}>
              {maps.map((m) => (
                <GridItem
                  title={m.frontmatter.title}
                  link={m.frontmatter.link}
                  image={m.frontmatter.featuredImage}
                  featured={m.frontmatter.featured}
                  products={m.frontmatter.products}
                  created={m.frontmatter.created}
                  description={m.frontmatter.description}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export const GridItem = ({ title, image, products, small }) => {
  const [hover, setHover] = useState(false)
  return (
    <Link to={`/maps/${kebabCase(title)}`}>
      <div
        className={styles.postCard}
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
      >
        <div
          className={`${styles.cardImage} ${hover && styles.hovered} ${small && styles.small
            }`}
        >
          <picture>
            {image?.endsWith('.jpg') && (
              <source srcSet={image.replace('.jpg', '.webp')} type="image/webp" />
            )}
            {image?.endsWith('.png') && (
              <source srcSet={image.replace('.png', '.webp')} type="image/webp" />
            )}
            <img src={image} alt={title} loading="lazy" />
          </picture>
        </div>
        <div className={`${styles.cardContent} ${hover && styles.hovered}`}>
          <h3>{title}</h3>
          {products?.length > 0 && (
            <div className={styles.products}>
              <Tooltip label={products.join(', ')} position="top" withArrow>
                <div className={styles.product}>
                  {products.includes('Data') && (
                    <EditorModeIcon color="var(--primary)" />
                  )}
                  {products.includes('Builder') && (
                    <PresentModeIcon color="var(--primary)" />
                  )}
                  {products.includes('Workflows') && (
                    <DivideByAttributeIcon color="var(--primary)" />
                  )}
                  {products.includes('Forms') && (
                    <FormsIcon color="var(--primary)" />
                  )}
                </div>
              </Tooltip>
              <span>
                {products.length > 1 ? 'Multi-product solution' : products[0]}
              </span>
            </div>
          )}
        </div>
      </div>
    </Link>
  )
}

export default MapGrid
